module.exports = __webpack_public_path__ + "img/control_point_duplicate.72acf357.svg";